import React, { Component } from "react";
import * as Hangul from "hangul-js";

import stl from "./BoardList.module.scss";

class BoardList extends Component {
	constructor(props) {
		super(props);
		this.state = {
			data: this.props.data,
			start: this.props.start,
			list: this.props.data.slice(this.props.start, this.props.pageSize),
			searchList: [],
			searchText: "",
			lastPage: 0,
			curPage: 1, // 현재 페이지
			viewCnt: this.props.viewCnt,
			pageSize: this.props.pageSize,
			totalCnt: this.props.data.length,
			pageBtn: [],
		};
	}

	componentDidMount() {
		// console.log(this.props);
		this._init();
	}

	componentDidUpdate(prevProps, prevState) {
		const { lastPage, curPage, searchText } = this.state;
		const { pageSize, data } = this.props;
		if (curPage !== prevState.curPage) {
			const lastPage = this.state.searchList.length > 0 ? Math.ceil(this.state.searchList.length / pageSize) : Math.ceil(data.length / pageSize);
			this.setState({
				list: this.state.searchList.length > 0 ? this.state.searchList.slice((curPage - 1) * pageSize, curPage * pageSize) : data.slice((curPage - 1) * pageSize, curPage * pageSize),
				lastPage: lastPage,
				pageBtn: this.createPageBtn(lastPage, curPage),
			});
		}
		if (data.length !== prevProps.data.length) {
			const lastPage = Math.ceil(data.length / pageSize);
			this.setState({
				list: data.slice((curPage - 1) * pageSize, curPage * pageSize),
				lastPage: lastPage,
				pageBtn: this.createPageBtn(lastPage, curPage),
			});
		}
		if (searchText !== prevState.searchText) {
			if (searchText !== "") {
				const list = data.filter((item) => {
					return Hangul.rangeSearch(item.title, searchText).length > 0;
				});
				const lastPage = Math.ceil(list.length / pageSize);
				this.setState({
					list: list.slice(this.props.start, this.props.pageSize),
					searchList: list,
					pageBtn: this.createPageBtn(lastPage, curPage),
				});
			} else {
				this.setState({
					list: this.props.data.slice(this.props.start, this.props.pageSize),
					searchList: [],
					pageBtn: this.createPageBtn(lastPage, curPage),
				});
			}
		}
	}

	// 초기 설정
	_init = () => {
		const { data, pageSize } = this.props;
		const lastPage = Math.ceil(data.length / pageSize);
		const pageBtn = this.createPageBtn(lastPage, 1);

		this.setState({
			list: data.slice(0, pageSize),
			lastPage: lastPage,
			pageBtn: pageBtn,
		});
	};

	// Pagination 버튼 생성
	createPageBtn = (lastPage, curPage) => {
		const { viewCnt } = this.props;
		let pageBtn = [];

		const fPage = curPage % viewCnt === 0 ? curPage - viewCnt + 1 : curPage - (curPage % viewCnt) + 1;
		const lPage = fPage + viewCnt - 1 > lastPage ? lastPage : fPage + viewCnt - 1;

		for (let i = fPage; i <= lPage; i++) {
			if (i === curPage) {
				pageBtn.push(
					<div key={i} className={`${stl.pagingBtn} ${stl.number} ${stl.active}`} onClick={this.handlePaging}>
						{i}
					</div>
				);
			} else {
				pageBtn.push(
					<div key={i} className={`${stl.pagingBtn} ${stl.number}`} onClick={this.handlePaging}>
						{i}
					</div>
				);
			}
		}
		return pageBtn;
	};

	// 페이지 버튼 클릭 시
	handlePaging = (e) => {
		this.setState({
			curPage: parseInt(e.target.innerText),
		});
	};

	// 다음 페이지
	handleNextPage = () => {
		this.setState({
			curPage: this.state.curPage === this.state.lastPage ? this.state.lastPage : this.state.curPage + 1,
		});
	};

	// 이전 페이지
	handlePrevPage = () => {
		this.setState({
			curPage: this.state.curPage - 1 === 0 ? 1 : this.state.curPage - 1,
		});
	};

	// 첫페이지
	handleFirstPage = () => {
		this.setState({
			curPage: 1,
		});
	};

	// 마지막 페이지
	handleLastPage = () => {
		this.setState({
			curPage: this.state.lastPage,
		});
	};

	// 검색어 입력
	changeInput = (e) => {
		const { name, value } = e.target;
		this.setState({
			[name]: value,
		});
	};

	// 상세보기 이동
	toDetail = (e) => {
		let id = "";
		if (e.target.nodeName === "svg") {
			id = e.target.parentElement.parentElement.children[1].innerText;
		} else {
			id = e.target.parentElement.children[1].innerText;
		}
		this.props.history.push("/notice/" + id);
		//window.location.href = "/notice/" + id;
	};

	render() {
		// console.log(this.state.list);
		return (
			<div id={stl.listWrapper}>
				<div className={`${stl.listContainer} ${stl.listWrapper}`}>
					<div className={stl.search}>
						<div className={stl.searchContainer}>
							<label><input type="text" className={stl.searchBox} name="searchText" placeholder="검색어를 입력해 주세요." onChange={this.changeInput} /></label>
						</div>
					</div>
					<div className={stl.list}>
						<table className={stl.listTable}>
							<caption>공지사항</caption>
							<thead>
								<tr>
									{this.props.children.map((item, idx) => {
										// console.log(this.props.name);
										return (
											<th key={idx} style={{ width: `${item.props.width}px` }} hidden={item.props.hidden} className={this.props.className}>
												{item.props.children}
											</th>
										);
									})}
								</tr>
							</thead>
							<tbody>
								{this.state.list.map((item, idx) => {
									return (
										<tr key={idx} className={stl.listItem}>
											{this.props.children.map((cItem, cIdx) => {
												return (
													<td key={cIdx} hidden={cItem.props.hidden} onClick={this.toDetail}>
														{item[cItem.props.dataField]}
													</td>
												);
											})}
										</tr>
									);
								})}
							</tbody>
						</table>
					</div>
				</div>
				{this.state.pageBtn.length > 1 && (
					<div className={`${stl.listContainer} ${stl.pagingWrapper}`}>
						<div className={`${stl.pagingBtn} ${stl.firstPage}`} onClick={this.handleFirstPage}></div>
						<div className={`${stl.pagingBtn} ${stl.prevPage}`} onClick={this.handlePrevPage}></div>
						{this.state.pageBtn}
						<div className={`${stl.pagingBtn} ${stl.nextPage}`} onClick={this.handleNextPage}></div>
						<div className={`${stl.pagingBtn} ${stl.lastPage}`} onClick={this.handleLastPage}></div>
					</div>
				)}
			</div>
		);
	}
}

export default BoardList;
